import { Component, inject } from '@angular/core';
import { BranchesService } from './services/branches.service';
import { CardModule } from 'primeng/card';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-branches',
  standalone: true,
  imports: [CardModule, RouterOutlet],
  templateUrl: './branches.component.html',
  styleUrl: './branches.component.css'
})
export class BranchesComponent {
  branchService = inject(BranchesService)

  ngOnInit(): void {
    this.branchService.title.update((value) => 'Sucursales')
  }
}
